import { render, staticRenderFns } from "./publications.vue?vue&type=template&id=ed6531ba&scoped=true"
import script from "./publications.vue?vue&type=script&lang=js"
export * from "./publications.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=ed6531ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6531ba",
  null
  
)

export default component.exports